import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import MasterGamesList from "../data/MasterGamesList"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function PragmaticDailyPrizeDrop({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "Gates of Olympus POP"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Gates of Olympus POP - Daily Prize Drops</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions{" "}
              </a>{" "}
              / <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> Gates of Olympus POP</h1>
                <h2>Daily Prize Drops</h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>Aug 3, 2026 (13:00) - Sept 28, 2026 (12:59)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {!isAppPromo && (
                  <div className="promotion-tnc-btn-wrapper">
                    <a
                      href="/slots/?provider=PP"
                      className="promotion-cta-btn"
                      style={{ cursor: "pointer" }}
                    >
                      Play Now
                    </a>
                  </div>
                )}

                <strong> Terms and Conditions: </strong>
                <ol>
                  <li>
                    <p>
                      549,850 prizes with a prize pool of ₱241,773,000 will be
                      given out from 3 August 2026 13:00 to 28 September 2026
                      12:59 (GMT+8).
                    </p>
                  </li>

                  <li>
                    <p>
                      Prize drops will run every day from 13:00pm to the
                      following day at 12:59pm (GMT+8) during the promotion
                      period:
                    </p>
                    <ul style={{ marginBottom: "0px" }}>
                      Schedule:
                      <li>
                        Weeks 1 & 5 (3–10 Aug & 31 Aug–7 Sep): 26,150 daily
                        winners, with prizes worth up to ₱12,615,000 per day.
                      </li>
                      <li>
                        Weeks 2–4 (10-31 Aug) & 6–8 (7-28 Sep): 4,375 daily
                        winners, with prizes worth up to ₱1,551,500 per day.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      To qualify, players must place a real money bet on “Gates
                      of Olympus POP” slot game.
                    </p>
                  </li>
                  <li>
                    <p>
                      Prizes are awarded as free spins in Gates of Olympus POP,
                      at the same bet stake used to win the prize. If bet stake
                      exceeds ₱58, each Free Spin will be awarded at ₱58.
                    </p>
                  </li>
                  <li>
                    <p>
                      Prizes are awarded as free spins in Gates of Olympus POP,
                      at the same bet stake used to win the prize. If bet stake
                      exceeds ₱58, each Free Spin will be awarded at ₱58.
                    </p>
                  </li>
                  <li>
                    <p>
                      Each player may win a maximum of 1 prize per day during
                      this promotion.
                    </p>
                  </li>
                  <li>
                    <p>No minimum bet is required for this promotion.</p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to thoroughly review
                      players activities to identify any potential abuse to
                      ensure fair play within our Network Promotion. If any
                      abuse is found, Pragmatic Play reserves the right to
                      forfeit any amounts paid to winning players.
                    </p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </p>
                  </li>
                  <li>
                    <p>Qualified Games: Gates of Olympus POP.</p>
                  </li>
                  {!isAppPromo && (
                    <MasterGamesList
                      qualifiedGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customQualifiedGames={[
                        {
                          provider: "pp",
                          gameName: "Gates of Olympus POP",
                        },
                      ]}
                      rank="off"
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  )}
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <th> Number of Prizes </th>
                      <th> Prizes </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 150 </td>
                        <td> 50 Free Spins</td>
                      </tr>
                      <tr>
                        <td> 1,000</td>
                        <td> 10 Free Spins</td>
                      </tr>
                      <tr>
                        <td> 25,000 </td>
                        <td> 8 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    href="https://pp88.asia/tl/gates-of-olympus-pop-daily-prize-drops/"
                    className="promotion-cta-btn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
